import Batch from 'smg/batch';
import * as hyejoo from 'smg/customer-api/hyejoo';
import * as lineitems from 'smg/customer-api/lineitems';
import * as models from 'smg/models';
import { G } from 'smg/querystring';
import { DrawQuoteOrOrderCartItem } from '../carts';

if (document.body.id === 'quote-search') {
    main();
}

function main() {
    const $spinnerContainer = document.querySelector('#quote-search-spinner-container') as HTMLElement;
    const $searchContainer = document.querySelector('#quote-search-container') as HTMLElement;
    const $resultsContainer = document.querySelector('#quote-search-results-container') as HTMLElement;
    const $results = document.querySelector('#quote-search-results') as HTMLElement;

    const $search = document.querySelector('#quote-search-input') as HTMLInputElement;

    const currQuery = G().Get('q');
    let q: string = currQuery || '';
    const quoteID = G().Get('id');
    const quoteSentInstanceID = G().Get('instance');

    const showSearch = () => {
        if (currQuery) {
            $search.value = currQuery;
        }

        $searchContainer.classList.remove('d-none');
        $spinnerContainer.remove();
    };

    if (quoteID) {
        if (quoteID.length === 43) { // key
            q = `key:${quoteID}`;
        } else {
            q = `id:${quoteID}`;
        }
    } else if (quoteSentInstanceID) {
        if (quoteSentInstanceID.length === 43) { // key
            q = `quoteSentKey:${quoteSentInstanceID}`;
        } else {
            q = `quoteSentInstanceID:${quoteSentInstanceID}`;
        }
    } else if (!q) {
        showSearch();
        return;
    }

    const b = new Batch();

    b.get<hyejoo.Quotes>('/v2/quotes', {
        params: {
            'sort': 'number asc,created asc',
            'max': 100,
            'data': 'serial,created,quoteLineItems,quoteProofs,cachedTotal,quoteOrders,quoteRequest,key',
            'q': q,
        },
    }).then(async resp => {
        if (!resp.data.quotes.length) {
            if (currQuery) {
                const emptySearchWarning = document.querySelector('#empty-search-warning') as HTMLElement;
                emptySearchWarning.classList.remove('d-none');
            }

            showSearch();
            return;
        }

        const f = document.createDocumentFragment();

        for (const quote of resp.data.quotes) {
            const fauxCartItem: models.CartItem = {
                quote,
                subtotal: quote.cachedTotal,
            };

            const $card = await DrawQuoteOrOrderCartItem({
                cartItem: fauxCartItem,
                disableDelete: true,
                addToCart: true,
            });
            if (!$card) {
                continue;
            }

            f.appendChild($card);
        }

        $spinnerContainer.remove();
        $results.appendChild(f);
        $resultsContainer.classList.remove('d-none');
    }).catch(err => {
        showSearch();
        throw err;
    });

    void lineitems.GetLineItems(b);

    void b.Exec();

    if (G().Get('ref') === 'search') {
        const $backToSearch = document.querySelector('#back-to-search-container') as HTMLElement;
        $backToSearch.classList.remove('d-none');
    }
}